module.exports = __webpack_public_path__ + "static/media/zalo.0f2eb4be.svg";